import { errorHandle } from 'redux/actions/error';
import apiService from 'shared/services/ApiService';
import { audiences } from 'shared/constant';

import {
  GET_LIST_COMPANY,
  GET_LIST_COMPANY_SUCCESS,
  GET_LIST_COMPANY_FAILED,
  GET_SINGLE_COMPANY,
  GET_SINGLE_COMPANY_SUCCESS,
  GET_SINGLE_COMPANY_FAILED,
  GET_AVAILABLE_MODULES_INIT,
  GET_AVAILABLE_MODULES_SUCCESS,
  GET_AVAILABLE_MODULES_ERROR,
  UPDATE_AVAILABLE_MODULES,
  UPDATE_EMPLOYEE_ROLES,
  INIT_SUBMIT_NEW_COMPANY,
  UPDATE_SUBMIT_MODAL_OPEN,
  CREATE_ORGANIZATION_SUCCESS,
  CREATE_ORGANIZATION_ERROR,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  CREATE_EMPLOYEE_SUCCESS,
  CREATE_EMPLOYEE_ERROR,
  UPDATE_SUBMIT_MODAL_FINISH_OPEN,
  RETRY_ORGANIZATION,
  RETRY_EMPLOYEE,
  RETRY_USER,
  RESET_AVAILABLE_MODULES,
  INIT_SUBMIT_NEW_EMPLOYEE,
  SHOW_ROLLBACK_MODAL,
  CANCEL_ROLLBACK_MODAL,
  ROLLBACK_USER,
  ROLLBACK_ORGANIZATION,
  ROLLBACK_ERROR,
  ROLLBACK_SUCCESS,
  ROLLBACK_FINISH,
  UPDATE_SUBMIT_MODAL_ERROR_OPEN,
  UPDATE_CREATE_NEW_COMPANY_STEP,
  RESET_SUBMIT_MODAL,
  GET_ALL_MODULES_SUCCESS,
  GET_ALL_MODULES_FAILED,
  GET_ALL_MODULES,
} from './types';

const { amonraApiService, auth0ApiService } = apiService.getInstance();

export const updateCreateNewCompanyStep = step => ({
  type: UPDATE_CREATE_NEW_COMPANY_STEP,
  step,
});

export const getListCompany = (
  paginationUrl,
  paramUrl = '',
  successCallback,
) => dispatch => {
  dispatch({ type: GET_LIST_COMPANY });

  const url = `organizations?${paginationUrl}${paramUrl}`;

  amonraApiService
    .get(url)
    .then(response => {
      dispatch({
        type: GET_LIST_COMPANY_SUCCESS,
        companyList: response.data.payload,
        pagination: response.data.pagination,
      });

      if (successCallback) {
        successCallback(response.data.pagination);
      }
    })
    .catch(error => {
      dispatch({
        type: GET_LIST_COMPANY_FAILED,
        payload: { companyList: [] },
      });
      errorHandle(error);
    });
};

export const getAllModules = () => dispatch => {
  dispatch({ type: GET_ALL_MODULES });
  amonraApiService
    .get(`modules`)
    .then(response => {
      dispatch({
        type: GET_ALL_MODULES_SUCCESS,
        allModules: response.data.payload,
      });
    })
    .catch(error => {
      dispatch({
        type: GET_ALL_MODULES_FAILED,
      });
      errorHandle(error);
    });
};

export const getSingleCompany = (orgId, callback) => dispatch => {
  dispatch({ type: GET_SINGLE_COMPANY });
  amonraApiService
    .get(`organizations/${orgId}`)
    .then(response => {
      dispatch({
        type: GET_SINGLE_COMPANY_SUCCESS,
        payload: { companyDetail: response.data },
      });

      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      dispatch({
        type: GET_SINGLE_COMPANY_FAILED,
        payload: { companyDetail: {} },
      });
      errorHandle(error);
    });
};

export const getAvailableModules = callback => dispatch => {
  dispatch(getAvailableModulesInit());

  amonraApiService
    .get(`modules`)
    .then(company.onGetAvailableModulesSuccess(dispatch, callback));
};

export const onGetAvailableModulesSuccess = (
  dispatch,
  callback,
) => response => {
  const newPayload = response.data.payload.map(module => {
    if (module.identifier === audiences.ORGANIZATION) {
      return {
        ...module,
        checked: true,
        disabled: true,
        view_all: false,
        viewAllDisabled: false,
      };
    }
    return {
      ...module,
      checked: false,
      disabled: false,
      view_all: false,
      viewAllDisabled: false,
    };
  });

  dispatch(company.getAvailableModulesSuccess(newPayload));

  if (callback) {
    callback(response.data);
  }
};

export const getAvailableModulesInit = () => ({
  type: GET_AVAILABLE_MODULES_INIT,
});

export const getAvailableModulesSuccess = payload => ({
  type: GET_AVAILABLE_MODULES_SUCCESS,
  payload,
});

export const getAvailableModulesError = error => ({
  type: GET_AVAILABLE_MODULES_ERROR,
  error,
});

export const updateAvailableModules = availableModules => ({
  type: UPDATE_AVAILABLE_MODULES,
  availableModules,
});

export const updateEmployeeRoles = employeeRoles => ({
  type: UPDATE_EMPLOYEE_ROLES,
  employeeRoles,
});

export const createNewCompany = params => dispatch => {
  dispatch(initSubmitNewCompany(params));

  company.startCreateOrganization(dispatch, params);
};

export const startCreateOrganization = (dispatch, params) => {
  amonraApiService
    .post(`organizations`, params.organization)
    .then(company.onCreateOrganizationSuccess(dispatch, params))
    .catch(company.onCreateOrganizationError(dispatch));
};

export const onCreateOrganizationSuccess = (dispatch, params) => response => {
  // update organization id in employee params
  params.employee.organization_id = response.data.payload.organization_id;
  dispatch(company.createOrganizationSuccess(params));

  // step 2: create user
  company.startCreateUser(dispatch, params);
};

export const onCreateOrganizationError = dispatch => () => {
  dispatch(company.createOrganizationError());
};

export const createOrganizationSuccess = params => ({
  type: CREATE_ORGANIZATION_SUCCESS,
  params,
});

export const createOrganizationError = () => ({
  type: CREATE_ORGANIZATION_ERROR,
});

export const startCreateUser = (dispatch, params) => {
  amonraApiService
    .post(`users`, params.user)
    .then(company.onCreateUserSuccess(dispatch, params))
    .catch(company.onCreateUserError(dispatch));
};

export const onCreateUserSuccess = (dispatch, params) => response => {
  // update user id in employee params
  params.employee.user_id = response.data.payload.user_id;
  dispatch(company.createUserSuccess(params));

  // step 3: create employee
  company.startCreateEmployee(dispatch, params);
};

export const onCreateUserError = dispatch => () => {
  dispatch(company.createUserError());
};

export const createUserSuccess = params => ({
  type: CREATE_USER_SUCCESS,
  params,
});

export const createUserError = () => ({
  type: CREATE_USER_ERROR,
});

export const startCreateEmployee = (dispatch, params) => {
  amonraApiService
    .post(`employees`, params.employee)
    .then(company.onCreateEmployeeSuccess(dispatch, params))
    .catch(company.onCreateEmployeeError(dispatch));
};

export const onCreateEmployeeSuccess = (dispatch, params) => response => {
  params.organization_id =
    response.data.payload.organization_details.organization_id;

  if (params.avatar) {
    company.startUploadUserImage(dispatch, params);
  } else {
    company.startChangePassword(dispatch, params);
  }
};

export const onCreateEmployeeError = dispatch => () => {
  dispatch(company.createEmployeeError());
};

export const createEmployeeSuccess = params => ({
  type: CREATE_EMPLOYEE_SUCCESS,
  params,
});

export const createEmployeeError = () => ({
  type: CREATE_EMPLOYEE_ERROR,
});

export const updateSubmitModalOpen = value => ({
  type: UPDATE_SUBMIT_MODAL_OPEN,
  value,
});

export const updateSubmitModalFinishOpen = (
  value,
  availableModules,
  employeeRoles,
) => ({
  type: UPDATE_SUBMIT_MODAL_FINISH_OPEN,
  value,
  availableModules,
  employeeRoles,
});

export const initSubmitNewCompany = params => ({
  type: INIT_SUBMIT_NEW_COMPANY,
  params,
});

export const startRetryCompany = params => dispatch => {
  dispatch(retryCompany());

  company.startCreateOrganization(dispatch, params);
};

export const startRetryUser = params => dispatch => {
  dispatch(retryUser());

  company.startCreateUser(dispatch, params);
};

export const startRetryEmployee = params => dispatch => {
  dispatch(retryEmployee());

  company.startCreateEmployee(dispatch, params);
};

export const retryCompany = () => ({
  type: RETRY_ORGANIZATION,
});

export const retryUser = () => ({
  type: RETRY_USER,
});

export const retryEmployee = () => ({
  type: RETRY_EMPLOYEE,
});

export const startUploadUserImage = (dispatch, params) => {
  const urlPath = `users/${params.employee.user_id}/avatar`;

  const formData = new FormData();
  formData.append('document', params.avatar);

  amonraApiService
    .post(urlPath, formData)
    .then(company.onUploadUserImageSuccess(dispatch, params))
    .catch(company.onUploadUserImageError(dispatch, params));
};

export const onUploadUserImageSuccess = (dispatch, params) => () => {
  company.startChangePassword(dispatch, params);
};

export const onUploadUserImageError = (dispatch, params) => () => {
  company.startChangePassword(dispatch, params);
};

export const resetAvailableModules = () => ({
  type: RESET_AVAILABLE_MODULES,
});

export const createNewEmployee = params => dispatch => {
  dispatch(company.initSubmitNewEmployee());

  // step 1: create user
  company.startCreateUser(dispatch, params);
};

export const initSubmitNewEmployee = () => ({
  type: INIT_SUBMIT_NEW_EMPLOYEE,
});

export const startChangePassword = (dispatch, params) => {
  const changePasswordUrl = `/dbconnections/change_password`;
  const param = {
    client_id: process.env.AUTH0_CLIENT_ID,
    email: params.user.email,
    connection: process.env.AUTH0_CONNECTION,
  };
  auth0ApiService
    .post(changePasswordUrl, param)
    .then(company.changePasswordSuccess(dispatch, params))
    .catch(company.changePasswordError(dispatch, params));
};

export const changePasswordSuccess = (dispatch, params) => () => {
  dispatch(company.createEmployeeSuccess(params));
};

export const changePasswordError = (dispatch, params) => () => {
  dispatch(company.createEmployeeSuccess(params));
};

export const showRollbackModal = () => ({
  type: SHOW_ROLLBACK_MODAL,
});

export const cancelRollbackModal = () => ({
  type: CANCEL_ROLLBACK_MODAL,
});

export const rollbackUser = () => ({
  type: ROLLBACK_USER,
});

export const rollbackOrganization = () => ({
  type: ROLLBACK_ORGANIZATION,
});

export const rollbackSuccess = () => ({
  type: ROLLBACK_SUCCESS,
});

export const rollbackError = () => ({
  type: ROLLBACK_ERROR,
});

export const rollbackFinish = () => ({
  type: ROLLBACK_FINISH,
});

export const startRollbackUser = params => dispatch => {
  dispatch(company.rollbackUser());

  const url = `users/${params.employee.user_id}`;
  amonraApiService
    .delete(url)
    .then(company.rollbackUserSuccess(dispatch, params))
    .catch(company.rollbackUserError(dispatch, params));
};

export const rollbackUserSuccess = (dispatch, params) => () => {
  if (params.organization) {
    dispatch(company.startRollbackOrganization(params));
  } else {
    dispatch(company.rollbackSuccess());
  }
};

export const rollbackUserError = dispatch => () => {
  dispatch(company.rollbackError());
};

export const startRollbackOrganization = params => dispatch => {
  dispatch(company.rollbackOrganization());

  const url = `organizations/${params.employee.organization_id}`;
  amonraApiService
    .delete(url)
    .then(company.rollbackOrganizationSuccess(dispatch))
    .catch(company.rollbackOrganizationError(dispatch));
};

export const rollbackOrganizationSuccess = dispatch => () => {
  dispatch(company.rollbackSuccess());
};

export const rollbackOrganizationError = dispatch => () => {
  dispatch(company.rollbackError());
};

export const updateCompany = params => dispatch => {
  dispatch(company.initSubmitNewCompany(params));

  // update step 1: update organization
  company.startUpdateOrganization(dispatch, params);
};

export const startUpdateOrganization = (dispatch, params) => {
  const url = `organizations/${params.organization_id}`;
  amonraApiService
    .patch(url, params.organization)
    .then(company.onUpdateOrganizationSuccess(dispatch, params))
    .catch(company.onUpdateOrganizationError(dispatch));
};

export const onUpdateOrganizationSuccess = (dispatch, params) => response => {
  // update organization id in employee params
  params.employee.organization_id = response.data.payload.organization_id;
  dispatch(company.createOrganizationSuccess(params));

  // step 2: update user
  company.startUpdateUser(dispatch, params);
};

export const onUpdateOrganizationError = dispatch => () => {
  dispatch(company.createOrganizationError());
};

export const startUpdateUser = (dispatch, params) => {
  const url = `users/${params.user_id}`;
  amonraApiService
    .patch(url, params.user)
    .then(company.onUpdateUserSuccess(dispatch, params))
    .catch(company.onUpdateUserError(dispatch));
};

export const onUpdateUserSuccess = (dispatch, params) => response => {
  // update user id in employee params
  params.employee.user_id = response.data.payload.user_id;
  dispatch(company.createUserSuccess(params));

  // step 3: update employee
  company.startUpdateEmployee(dispatch, params);
};

export const onUpdateUserError = dispatch => () => {
  dispatch(company.createUserError());
};

export const startUpdateEmployee = (dispatch, params) => {
  const url = `employees/${params.employee_id}`;
  amonraApiService
    .patch(url, params.employee)
    .then(company.onUpdateEmployeeSuccess(dispatch, params))
    .catch(company.onUpdateEmployeeError(dispatch));
};

export const onUpdateEmployeeSuccess = (dispatch, params) => () => {
  if (params.avatar) {
    company.startUpdateUserImage(dispatch, params);
  } else {
    dispatch(company.createEmployeeSuccess(params));
  }
};

export const onUpdateEmployeeError = dispatch => () => {
  dispatch(company.createEmployeeError());
};

export const startUpdateUserImage = (dispatch, params) => {
  const urlPath = `users/${params.user_id}/avatar`;

  const formData = new FormData();
  formData.append('document', params.avatar);

  amonraApiService
    .post(urlPath, formData)
    .then(company.onUpdateUserImageSuccess(dispatch, params))
    .catch(company.onUpdateUserImageError(dispatch, params));
};

export const onUpdateUserImageSuccess = (dispatch, params) => () => {
  dispatch(company.createEmployeeSuccess(params));
};

export const onUpdateUserImageError = (dispatch, params) => () => {
  dispatch(company.createEmployeeSuccess(params));
};

export const updateSubmitModalErrorOpen = value => ({
  type: UPDATE_SUBMIT_MODAL_ERROR_OPEN,
  value,
});

export const startRetryUpdateCompany = params => dispatch => {
  dispatch(retryCompany());

  company.startUpdateOrganization(dispatch, params);
};

export const startRetryUpdateUser = params => dispatch => {
  dispatch(retryUser());

  company.startUpdateUser(dispatch, params);
};

export const startRetryUpdateEmployee = params => dispatch => {
  dispatch(retryEmployee());

  company.startUpdateEmployee(dispatch, params);
};

export const resetSubmitModal = (newModules, newRoles) => ({
  type: RESET_SUBMIT_MODAL,
  newModules,
  newRoles,
});

const company = {
  getListCompany,
  getAllModules,
  getSingleCompany,
  getAvailableModules,
  onGetAvailableModulesSuccess,
  getAvailableModulesInit,
  getAvailableModulesSuccess,
  getAvailableModulesError,
  updateAvailableModules,
  updateEmployeeRoles,
  createNewCompany,
  startCreateOrganization,
  onCreateOrganizationSuccess,
  onCreateOrganizationError,
  createOrganizationSuccess,
  createOrganizationError,
  startCreateUser,
  onCreateUserSuccess,
  onCreateUserError,
  createUserSuccess,
  createUserError,
  startCreateEmployee,
  onCreateEmployeeSuccess,
  onCreateEmployeeError,
  createEmployeeSuccess,
  createEmployeeError,
  updateSubmitModalOpen,
  updateSubmitModalFinishOpen,
  initSubmitNewCompany,
  startRetryCompany,
  startRetryUser,
  startRetryEmployee,
  retryCompany,
  retryUser,
  retryEmployee,
  startUploadUserImage,
  onUploadUserImageSuccess,
  onUploadUserImageError,
  resetAvailableModules,
  createNewEmployee,
  initSubmitNewEmployee,
  startChangePassword,
  changePasswordSuccess,
  changePasswordError,
  showRollbackModal,
  cancelRollbackModal,
  rollbackUser,
  rollbackOrganization,
  rollbackSuccess,
  rollbackError,
  rollbackFinish,
  startRollbackUser,
  rollbackUserSuccess,
  rollbackUserError,
  startRollbackOrganization,
  rollbackOrganizationSuccess,
  rollbackOrganizationError,
  updateCompany,
  startUpdateOrganization,
  onUpdateOrganizationSuccess,
  onUpdateOrganizationError,
  startUpdateUser,
  onUpdateUserSuccess,
  onUpdateUserError,
  startUpdateEmployee,
  onUpdateEmployeeSuccess,
  onUpdateEmployeeError,
  startUpdateUserImage,
  onUpdateUserImageSuccess,
  onUpdateUserImageError,
  updateSubmitModalErrorOpen,
  startRetryUpdateCompany,
  startRetryUpdateUser,
  startRetryUpdateEmployee,
  updateCreateNewCompanyStep,
  resetSubmitModal,
};

export default company;
